module.exports = __webpack_public_path__ + "static/finley-0f4bb29d925e9e08a4acd1c1ad757c70.png";